import { Link } from "react-router-dom";
import { scrollToId } from "../lib/api";

export const Footer = ({ settings }) => (
  <footer className="relative overflow-hidden border-t border-white/10" data-testid="site-footer">
    <div className="mx-auto max-w-[1440px] px-5 pt-20 md:px-10">
      <div className="grid gap-10 md:grid-cols-12">
        <div className="md:col-span-6">
          <h2 className="font-display text-5xl uppercase leading-none text-white md:text-7xl">Ready to<br /><span className="text-[#a259ff] glow-cyan">run the city?</span></h2>
          <button onClick={() => scrollToId("catalog")} data-testid="footer-shop-button" className="mt-8 rounded-full bg-[#ff3dc8] px-7 py-4 font-mono text-sm font-bold uppercase tracking-widest text-white transition-shadow hover:shadow-[0_0_40px_rgba(255,61,200,0.55)]">
            Shop accounts
          </button>
        </div>
        <div className="space-y-3 font-mono text-xs uppercase tracking-widest text-slate-300 md:col-span-3 md:col-start-10">
          <p className="text-slate-400">Contact</p>
          {settings?.discord_url ? <a href={settings.discord_url} target="_blank" rel="noreferrer" className="block hover:text-[#a259ff]" data-testid="footer-discord-link">Discord</a> : <p>[Discord link — set in admin]</p>}
          {settings?.support_email ? <a href={`mailto:${settings.support_email}`} className="block normal-case hover:text-[#a259ff]" data-testid="footer-email-link">{settings.support_email}</a> : <p>[Support email — set in admin]</p>}
          <Link to="/find-order" className="block hover:text-[#a259ff]" data-testid="footer-find-order-link">Find my order</Link>
          <Link to="/admin" className="block hover:text-[#a259ff]" data-testid="footer-admin-link">Owner login</Link>
        </div>
      </div>
      <div className="mt-16 flex flex-col items-start gap-6 border-t border-white/10 pt-10 md:flex-row md:items-end md:justify-between">
        <img src={`${process.env.PUBLIC_URL}/brand/logo-full.png`} alt="OGM — Official GTA Modder. Modded accounts. Legit. Delivered." className="w-full max-w-md select-none" data-testid="footer-logo" />
        <span className="font-display text-[22vw] leading-[0.75] text-white/90 md:text-[14rem]">OGM</span>
      </div>
      <p className="py-8 text-xs text-slate-400">
        © {new Date().getFullYear()} OGM. Not affiliated with, endorsed by, or connected to Rockstar Games or Take-Two Interactive. GTA and Grand Theft Auto are trademarks of their respective owners.
      </p>
    </div>
  </footer>
);
